import createDataStore from './CreateDataContext';
import { fetchDocuments } from '../api/firebaseClientAPI';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_NEWS':
      return action.payload;
    default:
      return [];
  }
};

const fetchNews = (dispatch) => async () => {
  const news = await fetchDocuments('news', ['status', '==', 'active']);
  dispatch({ type: 'FETCH_NEWS', payload: news });
};

export const { Context, Provider } = createDataStore(
  reducer,
  { fetchNews },
  []
);
